export default __webpack_public_path__ + "static/media/14.807a1dfd.jpeg";